---
title: 'Step 3: Restart Collector'
install_track_title: 'Log Insights: Setup (Heroku Postgres)'
backlink_href: /docs/log-insights/setup
backlink_title: 'Log Insights: Setup'
---

import imgLogInsights from './log_insights.png'

export const ImgLogInsights = () => <img src={imgLogInsights} alt='Screenshot of pganalyze Log Insights feature' />

To finish, restart the collector app:

<CodeBlock language="bash">
{`heroku restart -a [your-collector-app-name]`}
</CodeBlock>

Afterwards, check the app logs again.

<CodeBlock language="bash">
{`heroku logs -a [your-collector-app-name] -t`}
</CodeBlock>

If the collector was able to match the log data to the correct database, you will see a log line like this after about a minute:

```
2018-05-20T21:22:19.854980+00:00 app[web.1]: I [TESTAPP_URL] Submitted compact snapshots successfully: 2 activity, 1 logs
```

<PublicOnly>
  <p>And then when you check the pganalyze interface, you will see Log Insights data:</p>
  <p>
    <ImgLogInsights />
  </p>
</PublicOnly>

Note that on Heroku Postgres you have [limited configuration options](https://devcenter.heroku.com/articles/heroku-postgres-settings),
but you may want to review the defaults of:

<CodeBlock language="text">
{`log_min_duration_statement = 2000
log_lock_waits = on
log_statement = ddl`}
</CodeBlock>

You can see details on what these settings do in our [tuning guide](https://pganalyze.com/docs/log-insights/setup/tuning-log-config-settings).
